import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"

interface IYesNotSelectProps {
  id?: string
  mainLabel: string
  yesLabel?: string
  notLabel?: string
  emptyLabel?: string
  disabled?: boolean
  unique?: boolean
  value: any
  onChange: (newValue: any) => any
}

const valueByName = {
  both: [null, undefined],
  yes: [true, 1],
  no: [false, 0]
}

const getValueKeyFromValue = (value: any): any => {
  if (valueByName.both.includes(value)) {
    return "both"
  }
  if (valueByName.yes.includes(value)) {
    return "yes"
  }
  if (valueByName.no.includes(value)) {
    return "no"
  }
}

const getValueFromValueKey = (valueKey: string): any => {
  if (valueKey === "both") {
    return valueByName.both[0]
  }
  if (valueKey === "yes") {
    return valueByName.yes[0]
  }
  if (valueKey === "no") {
    return valueByName.no[0]
  }
}

export const YesNotSelect = React.memo(
  ({ id, mainLabel, yesLabel, notLabel, emptyLabel, value, disabled, unique, onChange }: IYesNotSelectProps) => (
    <FormControl id={id} sx={{ width: "100%" }} size="small" disabled={disabled}>
      <InputLabel id={`${id}-label`}>{mainLabel}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={`${id}-input`}
        value={getValueKeyFromValue(value)}
        onChange={event => onChange(getValueFromValueKey(event.target.value))}
        input={<OutlinedInput label={mainLabel} />}>
        {!unique && (
          <MenuItem id={`${id}-option-0`} value={"both"}>
            {emptyLabel || translate("label.select.empty")}
          </MenuItem>
        )}
        <MenuItem id={`${id}-option-1`} value={"yes"}>
          {yesLabel || translate("label.select.yes")}
        </MenuItem>
        <MenuItem id={`${id}-option-2`} value={"no"}>
          {notLabel || translate("label.select.no")}
        </MenuItem>
      </Select>
    </FormControl>
  )
)
